import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class JiraReaderView extends View {
    setup() {
        this.label = "Jira";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.JIRA.id);
        this.model.set("isCDC", false);
        this.model.set("hasAutoSchemaConversion", window.location.href.indexOf("-to-create-schema") !== -1);
    }
}

module.View = JiraReaderView;
module.vent = new Backbone.Model();
export default module;
